export default __webpack_public_path__ + "static/media/3.06a69cdd.jpg";